export const honorsList = [
  'Detur Prize',
  'Junior Phi Beta Kappa',
  'Phi Beta Kappa',
  'John Harvard Scholar',
  'Harvard College Scholar',
  'Certificate for Civic Engagement',
];
